import stressHeroGradients from '@/app/[locale]/stress/_data/stressHeroGradients';
import LandingPageHero from '@/app/components/LandingPage/LandingPageHero';

const StressHero = () => {
  return (
    <LandingPageHero
      backgroundProps={{
        color: 'sandstone-300',
        gradients: stressHeroGradients,
      }}
      copy="stress_hero_copy"
      data-cy="stress-hero"
      eyebrow="stress_hero_eyebrow"
      images={[
        {
          localizedAlt: 'stress_hero_woman_destress_alt',
          src: 'stress/stress_hero_woman_destressing',
        },
        {
          localizedAlt: 'stress_hero_backgammon_alt',
          src: 'stress/stress_man_backgammon',
        },
      ]}
      textColor="text-[#3E2242]"
      title="stress_hero_title"
      titleProps={{ indentation: 'lg:pl-56' }}
    />
  );
};
export default StressHero;
